<template>
  <div>
    <FloorNav></FloorNav>
    <div class="floor-category">
      <div class="main-banner swiper-container" v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
            <a :href="item.link" :style="{'background-image': 'url(' + item.img + ')'}"></a>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <FloorCategory></FloorCategory>
    </div>
    <FloorProcess></FloorProcess>
    <FloorHostsale></FloorHostsale>
    <FloorAppraise></FloorAppraise>
    <FloorDescibe></FloorDescibe>
    <FloorGrade></FloorGrade>
    <FloorNews></FloorNews>
    <FloorPartner></FloorPartner>
    <FloorService></FloorService>
    <Sidebar></Sidebar>
  </div>
</template>

<script>
import Sidebar from '../../components/sidebar';

import FloorNav from './floor-nav';
import FloorProcess from './floor-process';
import FloorService from './floor-service';
import FloorPartner from './floor-partner';
import FloorNews from './floor-news';
import FloorGrade from './floor-grade';
import FloorAppraise from './floor-appraise';
import FloorHostsale from './floor-hotsale';
import FloorCategory from './floor-category';
import FloorDescibe from './floor-describe';

import modelStore from '@/core/models/store';
import commentStore from '@/core/comment/store';
import articleStore from '@/core/hsb-article/store';
import navDataStore from '@/core/navData/store';

import { getBannerConfig } from '@/apis/base';
import Vue from 'vue';

if (process.env.VUE_ENV !== 'server') {
  require('swiper/dist/css/swiper.css');
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
  Vue.use(VueAwesomeSwiper);
}

export default {
  components: {
    Sidebar,
    FloorNav,
    FloorProcess,
    FloorService,
    FloorPartner,
    FloorNews,
    FloorGrade,
    FloorAppraise,
    FloorHostsale,
    FloorCategory,
    FloorDescibe
  },
  asyncData ({ store, route }) {
    return Promise.all([
      store.dispatch('navData/fetchNavData', {classId: 1, brandId: -1}),
      store.dispatch('indexModels/fetchPageData', {classid: 1, brandid: -1}),
      store.dispatch('hsbComment/getCommentList'),
      store.dispatch('hsbArticle/getArticleList')
    ]);
  },
  registerModule (store, preserveState) {
    store.registerModule('navData', navDataStore, { preserveState });
    store.registerModule('indexModels', modelStore, { preserveState });
    store.registerModule('hsbComment', commentStore, { preserveState });
    store.registerModule('hsbArticle', articleStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('navData');
    this.$store.unregisterModule('indexModels');
    this.$store.unregisterModule('hsbComment');
    this.$store.unregisterModule('hsbArticle');
  },
  data () {
    return {
      bannerList: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        observeParents: true,
        observer: true
      }
    };
  },
  mounted () {
    getBannerConfig().then(res => {
      if (res._errCode === '0') {
        this.bannerList = res._data.banner;
      }
    }).catch(err => {
      console.log(err);
    });
  }
};
</script>

<style scoped>
@import 'config.css';
.floor-category {
  position: relative;
  height: 400px;
}
.swiper-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.swiper-pagination {
  bottom: 10px;
  left: 0;
  width: 100%;

  /deep/ .swiper-pagination-bullet {
    margin: 0 4px;
  }
}

.swiper-slide {
  a {
    display: block;
    width: 100%;
    height: 400px;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/index.vue